export enum EnumTipoAlerta {
  EmpleadoPreocupante = 1,
  ClientePreocupante = 2,
}
export enum EnumGlobals {
  AnniosHistoricos = 10,
  DivolLeasingId = 19
}
